import React, { Component, Fragment } from 'react';
import styled from '@emotion/styled';

import { LIGHT_COLOR } from './ThemeIFProfs';

import UIWidth from './UIWidth';
import Img from './Img';

import BackgroundImage from './img/bg-square.svg';
import LogoMinistere from './img/logo-ministere-de-la-culture.svg';
import LogoInstitutFrancais from './img/logo-institut-francais.svg';
import Twitter from './img/icons/Twitter';
import Facebook from './img/icons/Facebook';
import LinkedIn from './img/icons/LinkedIn';

const MainFooter = styled.div`
  background-color: ${props => props.theme.secondaryColor};
  padding: 15px 0;
  background-image: url(${BackgroundImage.src});
  background-size: 227px 227px;
  color: ${props => props.theme.lightColor};
  font-family: ${props => props.theme.mainFont};
  font-size: 0.875rem;
  line-height: 1.6;
  @media print {
    display: none;
  }
`;
const Flexbox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  @media (min-width: ${props => props.theme.tablet}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;
const IsolatedBlocks = styled.div`
  display: flex;
  align-items: center;
  margin: 1em 0;
  flex-direction: ${props =>
    props.verticalContainerForMobile ? 'column' : 'row'};
  @media (min-width: ${props => props.theme.tablet}) {
    flex-direction: row;
    flex-basis: ${props => (props.flexBasis ? props.flexBasis : 'auto')};
    justify-content: center;
  }
`;
const LogoContainer = styled.span`
  display: inline-block;
  margin: 0 0.5em;
`;
export const A = styled.a`
  display: inline-block;
  color: ${props => props.theme.lightColor};
`;
export const Dash = styled.span`
  display: none;
  @media (min-width: ${props => props.theme.xl}) {
    display: inline-block;
    padding: 0 0.5em;
  }
`;

class Footer extends Component {
  render() {
    return (
      <MainFooter>
        <UIWidth alternateWidth>
          <Flexbox>
            <IsolatedBlocks flexBasis="30%">
              <LogoContainer>
                <A href="http://www.diplomatie.gouv.fr/">
                  <Img
                    src={LogoMinistere.src}
                    width={LogoMinistere.width}
                    height={LogoMinistere.height}
                    imgWidth="4rem"
                    imgHeight="5.5625rem"
                    alt="(Logo) Ministère de l'Europe et des Affaires étrangères | Ministère de la Culture. Suivez ce lien pour visiter le site diplomatie.gouv.fr."
                  />
                </A>
              </LogoContainer>
              <LogoContainer>
                <A href="http://www.institutfrancais.com/">
                  <Img
                    src={LogoInstitutFrancais.src}
                    width={LogoInstitutFrancais.width}
                    height={LogoInstitutFrancais.height}
                    imgWidth="7.5rem"
                    imgHeight="4.3125rem"
                    alt="(Logo) Institut Français. Suivez ce lien pour visiter le site institutfrancais.com"
                  />
                </A>
              </LogoContainer>
            </IsolatedBlocks>
            <IsolatedBlocks verticalContainerForMobile>
              ©2019
              {new Date().getFullYear() > 2019 && (
                <Fragment>
                  {'-'}
                  {new Date().getFullYear()}
                </Fragment>
              )}
              , Tous droits réservés
              {this.props.mainFooterLinks}
            </IsolatedBlocks>
            <IsolatedBlocks flexBasis="30%">
              <LogoContainer>
                <A
                  href="https://twitter.com/IFprofs"
                  target="_blank"
                  title="Notre fil Twitter"
                >
                  <Twitter iconColor={LIGHT_COLOR} iconWidth="4rem" />
                  <span className="screen-reader-only">Notre fil Twitter</span>
                </A>
              </LogoContainer>
              <LogoContainer>
                <A
                  href="https://www.facebook.com/IFprofs/"
                  target="_blank"
                  title="Notre page Facebook"
                >
                  <Facebook iconColor={LIGHT_COLOR} iconWidth="4rem" />
                  <span className="screen-reader-only">
                    Notre page Facebook
                  </span>
                </A>
              </LogoContainer>
              <LogoContainer>
                <A
                  href="https://www.linkedin.com/company/ifprofs/"
                  target="_blank"
                  title="Notre page LinkedIn"
                >
                  <LinkedIn iconColor={LIGHT_COLOR} iconWidth="4rem" />
                  <span className="screen-reader-only">
                    Notre page LinkedIn
                  </span>
                </A>
              </LogoContainer>
            </IsolatedBlocks>
          </Flexbox>
        </UIWidth>
      </MainFooter>
    );
  }
}

export default Footer;
